var map = {
	"./dennerle.jpg": 73150,
	"./filippov.jpg": 88321,
	"./hans-barth.jpg": 80990,
	"./hirurg.jpg": 51982,
	"./kermit.jpg": 27588,
	"./kras-aqua.jpg": 1697,
	"./nature.jpg": 88014,
	"./oriental.jpg": 67675,
	"./other.jpg": 93402,
	"./zoologica.jpg": 24663
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 10300;